<!-- 待办 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('报装类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择报装类型')">
                <a-select-option :value="1">{{ $t('个人新装') }}</a-select-option>
                <a-select-option :value="6">{{ $t('企业新装') }}</a-select-option>
                <a-select-option :value="5">{{ $t('用水') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag
                v-model="queryParam.ticketsEmergency"
                :placeholder="$t('请选择工单紧急程度')"
                dictCode="ticketsEmergency"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <!-- <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="任务节点">
                <j-dict-select-tag v-model="queryParam.currentNode" placeholder="请选择任务节点"
                  dictCode="currentNode" style="width:100%" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="申请时间">
                <a-date-picker placeholder="请选择申请时间" valueFormat="YYYY-MM-DD 00:00:00" v-model="queryParam.createTime"  style="width: 100%" />
              </a-form-item>
            </a-col>
          </template> -->
          <template v-if="toggleSearchStatus">
            <a-form-item :label="$t('创建人员')">
              <a-select v-model="queryParam.createBy" :placeholder="$t('请选择创建人员')">
                <a-select-option value="微信端游客">{{ $t('微信端游客') }}</a-select-option>
                <a-select-option v-for="item in pList" :key="item.username" :value="item.username">{{
                  item.username
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :components="drag(columns)"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <!-- 报装编号 -->
        <span slot="ticketsNum" slot-scope="text, record">
          <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span @click.stop="copySampleNoLink(record.ticketsNum)" class="copySampleNo"><a-icon type="copy" /></span>
        </span>

        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="red" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="yellow" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="blue" v-else-if="text == 3">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>

        <template slot="ticketsState" slot-scope="text, record">
          <!-- 工程报装 - 新装 -->
          <span v-if="[1, 6].includes(record.ticketsType)">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ engineeringList[text] }}
            </template>
          </span>
          <!-- 工程报装 - 用水 -->
          <span v-if="record.ticketsType == 5">
            <template v-if="record.ticketsState == -1"> {{ $t('已结束') }} </template>
            <template v-else>
              {{ engineeringWaterList[text] }}
            </template>
          </span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleClaim(record)">{{ $t('签收') }}</a>
          <a-divider type="vertical" />
          <!-- <a @click="handleDelegate(record)">委派</a>
                  <a-divider type="vertical" /> -->
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <TaskActHistoricDetailBtn :data-id="record.id" v-if="record.ticketsState != 0"></TaskActHistoricDetailBtn>
        </span>
      </a-table>
    </div>

    <construction-detail-modal ref="modalForm" @ok="modalFormOk"></construction-detail-modal>
    <Examine ref="ExamineForm" @ok="modalFormOk"></Examine>
    <SurveyInformation ref="SurveyInformationForm" @ok="modalFormOk"></SurveyInformation>
    <Drawing ref="DrawingForm" @ok="modalFormOk"></Drawing>
    <LeaderApproval ref="LeaderApprovalForm" @ok="modalFormOk"></LeaderApproval>
    <EnterContract ref="EnterContractForm" @ok="modalFormOk"></EnterContract>
    <FinancialConfirmation ref="FinancialConfirmationForm" @ok="modalFormOk"></FinancialConfirmation>
    <LeaderDispatch ref="LeaderDispatchForm" @ok="modalFormOk"></LeaderDispatch>
    <EnterConstruction ref="EnterConstructionForm" @ok="modalFormOk"></EnterConstruction>
    <EngineeringAcceptance ref="EngineeringAcceptanceForm" @ok="modalFormOk"></EngineeringAcceptance>
    <putOnRecord ref="putOnRecordForm" @ok="modalFormOk"></putOnRecord>
    <EngineeringInstallationDetail
      ref="EngineeringInstallationDetailForm"
      @ok="modalFormOk"
    ></EngineeringInstallationDetail>
    <!-- 施工申请 -->
    <ExcavationApplication ref="excavationApplicationFrom" @ok="modalFormOk"></ExcavationApplication>
    <!-- 核验稽查 -->
    <VerificationAndInspection ref="verificationAndInspectionFrom" @ok="modalFormOk"></VerificationAndInspection>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ConstructionDetailModal from './modules/apply/ConstructionDetailModal'
import TaskActHistoricDetailBtn from './modules/flowable/TaskActHistoricDetailBtn.vue'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import Examine from './modules/examine/ConstructionDetailModal' //工程部审核、审核
import SurveyInformation from './modules/surveyInformation/ConstructionDetailModal' //录入勘测信息
import Drawing from './modules/drawing/ConstructionDetailModal' //录入图纸和预算
import LeaderApproval from './modules/leaderApproval/ConstructionDetailModal' //审批图纸和预算、审批合同
import EnterContract from './modules/enterContract/ConstructionDetailModal' //录入合同
import FinancialConfirmation from './modules/financialConfirmation/ConstructionDetailModal' //财务确认
import LeaderDispatch from './modules/leaderDispatch/ConstructionDetailModal' //领导审批派单
import EnterConstruction from './modules/enterConstruction/ConstructionDetailModal' //录入施工文件
import EngineeringAcceptance from './modules/engineeringAcceptance/ConstructionDetailModal' //工程验收
import putOnRecord from '@/views/workOrderManagement/workManagement/modules/putOnRecord' //建档
import EngineeringInstallationDetail from '@/views/workOrderManagement/workManagement/modules/EngineeringInstallationDetail' //全部流程详情
import ExcavationApplication from './modules/ExcavationApplication/ConstructionDetailModal' //施工申请
import VerificationAndInspection from './modules/VerificationAndInspection/ConstructionDetailModal' //施工申请
import { postAction, getAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import TableDragResize from '@/mixins/TableDragResize'
import Vue from 'vue'
import { SYS_TYPE } from '@/store/mutation-types'
import store from '@/store/'

export default {
  name: 'ConstructionDetailList',
  mixins: [JeecgListMixin, mixinDevice, TableDragResize],
  components: {
    ConstructionDetailModal,
    TaskActHistoricDetailBtn,
    Examine,
    SurveyInformation,
    Drawing,
    LeaderApproval,
    EnterContract,
    FinancialConfirmation,
    LeaderDispatch,
    EnterConstruction,
    EngineeringAcceptance,
    putOnRecord,
    EngineeringInstallationDetail,
    ExcavationApplication,
    VerificationAndInspection,
    JInput,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      url: {
        list: '/jeecg-engineering/ticket/tickets/list',
        delete: '/jeecg-engineering/engineering/installationDetail/delete',
        deleteBatch: '/jeecg-engineering/engineering/installationDetail/deleteBatch',
        // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
        // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
        start: '/jeecg-engineering/engineering/installationDetail/startProcess/engineering',
        userList: '/sys/user/list',
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        claim: '/jeecg-engineering/flowable/task/claim',
      },
      dictOptions: {},
      superFieldList: [],
      queryParam: {
        workState: 4,
        belongModule: 'installation',
      },
      pList: [],
    }
  },
  created() {
    this.getSuperFieldList()
    this.getPersonnelList()
  },
  computed: {
    description() {
      return this.$t('construction_detail管理页面')
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('工单编号'),
          align: 'center',
          dataIndex: 'ticketsNum',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'ticketsNum' },
        },
        {
          title: this.$t('报装类型'),
          align: 'center',
          dataIndex: 'ticketsType',
          customRender: (t, r, index) => {
            if (t == 0) {
              return this.$t('换表')
            } else if (t == 1) {
              return this.$t('个人新装')
            } else if (t == 2) {
              return this.$t('故障报修')
            } else if (t == 3) {
              return this.$t('报停')
            } else if (t == 4) {
              return this.$t('复接')
            } else if (t == 6) {
              return this.$t('企业新装')
            } else if (t == 5) {
              return this.$t('用水')
            }
          },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('工单紧急程度'),
          align: 'center',
          dataIndex: 'ticketsEmergency',
          // customRender: function (text) {
          //   return filterDictTextByCache('ticketsEmergency', text)
          // },
          scopedSlots: { customRender: 'ticketsEmergency' },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('工单状态'),
          dataIndex: 'ticketsState',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'ticketsState' },
        },
        {
          title: this.$t('用户名称'),
          align: 'center',
          dataIndex: 'ticketsContact',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户电话'),
          align: 'center',
          dataIndex: 'ticketsContactPhone',
          width: 150,
          ellipsis: true,
        },
        // {
        //     title: '报装状态',
        //     align: "center",
        //     dataIndex: 'installationState',
        //     customRender: function (text) {
        //         return filterDictTextByCache('installationState', text)
        //     },
        //     width: 150,
        //     ellipsis: true,
        // },
        {
          title: this.$t('当前节点处理人'),
          align: 'center',
          dataIndex: 'approverName',
          customRender: (text) => {
            if (text) {
              return text
            } else {
              return '/'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('申请人'),
          align: 'center',
          dataIndex: 'createBy',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('申请时间'),
          align: 'center',
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('更新时间'),
          align: 'center',
          dataIndex: 'updateTime',
          width: 150,
          ellipsis: true,
        },
        // {
        //     title: '历时',
        //     align: "center",
        //     dataIndex: 'diachronic',
        //     width: 150,
        //     ellipsis: true,
        // },
        {
          title: this.$t('来源'),
          align: 'center',
          dataIndex: 'sourceType',
          customRender: (text) => {
            if(text == 1){
              return this.$t('小程序')
            }else if(text == 2){
              return this.$t('公众号')
            }else{
              return 'PC'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 250,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    // 新装
    engineeringList() {
      return [
        this.$t('新建工单'),
        this.$t('现场勘察'),
        this.$t('设计方案'),
        this.$t('预算'),
        this.$t('领导审批'),
        this.$t('财务缴费'),
        this.$t('现场施工'),
        // '施工申请',
        // '核验稽查',
        this.$t('大厅复核'),
        this.$t('归档'),
        this.$t('关闭'),
      ]
    },
    // 用水
    engineeringWaterList() {
      return [
        this.$t('新建工单'),
        this.$t('现场勘察'),
        this.$t('设计方案'),
        this.$t('预算'),
        this.$t('领导审批'),
        this.$t('财务缴费'),
        this.$t('现场施工'),
        this.$t('大厅复核'),
        this.$t('归档'),
        this.$t('关闭'),
      ]
    },
  },
  methods: {
    getPersonnelList() {
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.pList = res.result.records
        }
      })
    },
    searchReset() {
      this.queryParam = {
        workState: 4,
        belongModule: 'installation',
      }
      this.loadData()
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'installationId', text: '报装id' })
      fieldList.push({ type: 'string', value: 'companyId', text: '公司id' })
      fieldList.push({ type: 'int', value: 'isAcceptance', text: '是否需要验收' })
      fieldList.push({ type: 'string', value: 'projectDetail', text: '项目说明' })
      fieldList.push({ type: 'int', value: 'isDesignChanges', text: '是否存在设计变更' })
      fieldList.push({ type: 'string', value: 'constructionRemark', text: '施工备注' })
      fieldList.push({ type: 'string', value: 'constructionAnnex', text: '施工附件' })
      fieldList.push({ type: 'int', value: 'ticketsEmergency', text: '工单紧急程度' })
      fieldList.push({ type: 'string', value: 'acceptanceAnnex', text: '验收附件' })
      fieldList.push({ type: 'string', value: 'remark', text: '备注信息' })
      this.superFieldList = fieldList
    },
    // 新装操作
    handleNewInstallOption(row) {
      this.$nextTick(() => {
        if (row.ticketsState == 1) {
          //勘察设计
          this.$refs.SurveyInformationForm.edit(row, false)
        } else if (row.ticketsState == 2) {
          // 设计方案与预算
          this.$refs.DrawingForm.edit(row, false)
        } else if (row.ticketsState == 3) {
          // 领导审批
          this.$refs.LeaderApprovalForm.edit(row, false)
        } else if (row.ticketsState == 4) {
          // 财务收费
          this.$refs.FinancialConfirmationForm.edit(row, false)
        } else if (row.ticketsState == 5) {
          //施工
          this.$refs.EnterConstructionForm.edit(row, false)
        } else if (row.ticketsState == 6) {
          //开挖申请
          this.$refs.excavationApplicationFrom.edit(row, false)
        } else if (row.ticketsState == 7) {
          //核验稽查
          this.$refs.verificationAndInspectionFrom.edit(row, false)
        } else if (row.ticketsState == 8) {
          //大厅复核
          this.$refs.LeaderApprovalForm.edit(row, false)
        } else if (row.ticketsState == 9) {
          //归档
        }
      })
    },
    // 用水操作
    handleUsedWaterOption(row) {
      this.$nextTick(() => {
        if (row.ticketsState == 1) {
          //勘察设计
          this.$refs.SurveyInformationForm.edit(row, false)
        } else if (row.ticketsState == 2) {
          // 设计方案与预算
          this.$refs.DrawingForm.edit(row, false)
        } else if (row.ticketsState == 3) {
          // 领导审批
          this.$refs.LeaderApprovalForm.edit(row, false)
        } else if (row.ticketsState == 4) {
          // 财务收费
          this.$refs.FinancialConfirmationForm.edit(row, false)
        } else if (row.ticketsState == 5) {
          //施工
          this.$refs.EnterConstructionForm.edit(row, false)
        } else if (row.ticketsState == 6) {
          //大厅复核
          this.$refs.LeaderApprovalForm.edit(row, false)
        }
      })
    },
    // 用水
    handleNodes(row) {
      this.$nextTick(() => {
        if (row.ticketsState == 1) {
          //报装申请处理
          this.$refs.ExamineForm.edit(row, false)
        } else if (row.currentNode == 2) {
          //受理
          this.$refs.ExamineForm.edit(row, false)
        } else if (row.currentNode == 3) {
          //勘察设计
          this.$refs.SurveyInformationForm.edit(row, false)
        } else if (row.currentNode == 4) {
          //预算
          this.$refs.DrawingForm.edit(row, false)
        } else if (row.currentNode == 5) {
          //审批
          this.$refs.LeaderApprovalForm.edit(row, false)
        } else if (row.currentNode == 6) {
          //收费
          this.$refs.FinancialConfirmationForm.edit(row, false)
        } else if (row.currentNode == 7) {
          //施工
          this.$refs.EnterConstructionForm.edit(row, false)
        } else if (row.currentNode == 8) {
          //验收
          this.$refs.EngineeringAcceptanceForm.edit(row, false)
        } else if (row.currentNode == 9) {
          //建档
          this.$refs.putOnRecordForm.init(row, false)
        }
      })
    },
    // 归档
    handleArchive(record) {
      this.loading = true
      let that = this
      let httpurl = this.url.pass
      let params = {
        dataId: record.id,
        values: {
          dataId: record.id,
        },
        comment: '',
      }
      postAction(httpurl, params)
        .then(res => {
          if (res.success) {
            that.$message.success(that.$t('操作成功'))
          } else {
            that.$message.warning(res.message)
          }
          that.loading = false
          that.loadData()
        })
        .finally(() => {
          that.loading = false
          that.loadData()
        })
    },
    // 审核
    handleAudit(row) {
      this.$nextTick(() => {
        this.$refs.ExamineForm.edit(row)
      })
    },
    // 开启
    handleStart(row) {
      this.loading = true
      postAction(this.url.start, { dataId: row.ticketsId }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('开启成功'))
          this.loading = false
          this.loadData()
        } else {
          this.$message.error(this.$t('开启失败'))
          this.loading = false
        }
      })
    },
    modalFormOk() {
      this.loading = true
      this.loadData()
    },
    handleDetail(row) {
      this.$nextTick(() => {
        this.$refs.EngineeringInstallationDetailForm.init(row, false)
      })
    },
    handleOrder(row) {
      this.loading = true
      let params = {
        dataId: row.id,
        values: {
          dataId: row.id,
        },
        comment: '',
      }
      postAction(this.url.pass, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('接单成功'))
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleClaim(row) {
      this.confirmLoading = true
      postAction(this.url.claim, { dataId: row.id })
        .then(res => {
          if (res.success) {
            this.$message.success(this.$t('签收成功'))
            // 签收成功后 进入我的待办页面 打开处理页面
            // Vue.ls.set(SYS_TYPE, 8)
            // store.commit('SET_SYSTYPE', 8)
            // this.$router.replace({ path: "/workOrderManagement/workManagement/index",query:{ticketsNum:row.ticketsNum} });
            this.$router.push({
              path: '/engineeringInstallation/constructionManagement/toDoList',
              query: { ticketsNum: row.ticketsNum },
            })
          } else {
            this.$message.error(res.message)
          }
          this.loadData()
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
